import { alpha } from '@mui/material';
import { palette } from '@client/theme/colors';
import { radii, theme } from '@client/theme/constants';
import { typography } from '@client/theme/typography';
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Table' {
  interface TablePropsSizeOverrides {
    condensed: true;
    padded: true;
  }
}

const Table: ThemeOptions['components'] = {
  MuiTable: {
    styleOverrides: {
      root: {
        borderColor: palette.text.primary,

        '& > :last-child > tr:last-child > td': {
          borderBottom: 'none',
        },

        '& td[rowSpan]': {
          borderBottom: 'none',
        },
      },
    },
    variants: [
      {
        props: { size: 'condensed' },
        style: {
          '& tr > td': {
            padding: theme.spacing(1.5, 2, 1.5, 1.5),
          },

          '& tr > th': {
            fontWeight: 600,
            padding: theme.spacing(0, 2, 1.5, 1.5),
            color: palette.text.secondary,
          },

          '& tr > td:first-of-type, & tr > th:first-of-type': {
            paddingLeft: 0,
          },

          '& tr > td:last-of-type, & tr > th:last-of-type': {
            paddingRight: 0,
          },

          '& > tfoot > tr > td': {
            color: palette.text.disabled,
          },
        },
      },
      {
        props: { size: 'padded' },
        style: {
          backgroundColor: palette.grey[200],
          borderRadius: radii.small,

          '& tr > td': {
            ...typography.subtitle1,
            borderColor: palette.divider,
            color: palette.text.secondary,
            padding: theme.spacing(1.5),
          },

          '& tr > th': {
            ...typography.subtitle2,
            borderColor: palette.divider,
            color: palette.text.secondary,
            padding: theme.spacing(1.5),
          },
        },
      },
    ],
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        ...typography.body1,
      },
      paddingNone: {
        padding: theme.spacing(1 / 2, 2),
      },
      footer: {
        ...typography.body1,
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: alpha(palette.primary.main, 0.08),

          '&:hover': {
            backgroundColor: alpha(palette.primary.main, 0.08),
          },
        },
      },
    },
  },
};

export default Table;
